// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon[data-v-3c9d5664] {\n  color: #a3bac0;\n}\n.wrapper[data-v-3c9d5664] {\n  text-align: center;\n  font-size: 0.625rem !important;\n}", ""]);
// Exports
module.exports = exports;
